import { useToast } from '@chakra-ui/react';

// const { toast } = createStandaloneToast();

export const useToastNotification = () => {
  const toast = useToast();
  
  const showToast = (title, description, status) => {
    toast({
      title,
      description,
      status,
      duration: 5000,
      isClosable: true,
      position: 'top-right',
    });
  };

  return { showToast };
};
